// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"726e2d4b","670":"47838198","837":"5ce8cf94"}[chunkId] + ".chunk.js";
};